import axios from 'axios';
import ls from 'local-storage';
import { UAParser } from 'ua-parser-js';
import { Utm } from 'utm-extractor';

import CommonHelper from '../helpers/CommonHelper';
import { isBlank } from './storeUtils';

export function getInitialUrl() {
  if (typeof window === 'undefined') return '';

  const x = ls('initial_url');
  if (x == undefined) {
    ls('initial_url', window.location.href);
    return window.location.href;
  }
  return x;
}

export function getInitialReferrer() {
  if (typeof window === 'undefined') return '';

  try {
    const x = ls('initial_referrer');
    if (x == undefined) {
      ls('initial_referrer', document.referrer);
      return document.referrer;
    }
    return x;
  } catch (_exc) {
    // Error intentionally ignored
    return '';
  }
}

export function getDeviceParams() {
  if (typeof window === 'undefined') return {};

  const parser = new UAParser(window.navigator.userAgent);
  const parserResults = parser.getResult();

  const os = parserResults?.os;
  const isAndroid = `${os?.name}`.toLowerCase().indexOf('android') > -1;
  const isIos = `${os?.name}`.toLowerCase().indexOf('ios') > -1;
  const isMobile = isAndroid == true || isIos == true;

  return {
    isMobile: isMobile == true ? 1 : 0,
    isAndroid: isAndroid == true ? 1 : 0,
    isIos: isIos == true ? 1 : 0,
    os: os?.name,

    userAgent: navigator.userAgent,
    platform: navigator.platform,
    deviceMemory: navigator.deviceMemory,
    hardwareConcurrency: navigator.hardwareConcurrency,
    language: navigator.language,
    languages: navigator.languages,
    maxTouchPoints: navigator.maxTouchPoints,
    cookieEnabled: navigator.cookieEnabled,
    doNotTrack: navigator.doNotTrack,
    vendor: navigator.vendor,
    vendorSub: navigator.vendorSub,
    product: navigator.product,
    productSub: navigator.productSub,
    appVersion: navigator.appVersion,
    appName: navigator.appName,
    appCodeName: navigator.appCodeName,

    screen_width: window.screen.width,
    screen_height: window.screen.height,
    screen_availWidth: window.screen.availWidth,
    screen_availHeight: window.screen.availHeight,
    screen_colorDepth: window.screen.colorDepth,
    screen_pixelDepth: window.screen.pixelDepth,

    devicePixelRatio: window.devicePixelRatio,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    outerWidth: window.outerWidth,
    outerHeight: window.outerHeight,
    location: window.location.href
  };
}

export function getUtm() {
  if (typeof window === 'undefined') return {};

  try {
    const initialUrl = getInitialUrl();
    const initialReferrer = getInitialReferrer();

    const utm = new Utm(initialUrl);
    const utlValues = utm.get();
    const isRefererUrl =
      initialReferrer != undefined && initialReferrer != '' && initialReferrer.length > 10;

    if (utlValues == undefined) {
      return {
        initialUrl: initialUrl,
        hasReferer: isRefererUrl == true ? 1 : 0,
        initialReferrer: initialReferrer,
        subid: gup('subid'),
        via: gup('via')
      };
    }
    const utlValuesWithNoLoDash = {};
    Object.keys(utlValues).forEach(key => {
      utlValuesWithNoLoDash[key.replace(/_/g, '-')] = utlValues[key];
    });
    return {
      ...utlValuesWithNoLoDash,
      initialUrl: initialUrl,
      initialReferrer: initialReferrer,
      hasReferer: isRefererUrl == true ? 1 : 0,
      subid: gup('subid'),
      via: gup('via')
    };
  } catch (_exc) {
    return {};
  }
}

export function getToken() {
  if (typeof window === 'undefined') return undefined;
  const token = window.localStorage.getItem('token')?.replace(/^"|"$/g, '');
  if (isBlank(token) || token.length < 10) {
    return undefined;
  }
  return token;
}

export function getGuestId() {
  if (typeof window === 'undefined') return '';

  let s = ls.get('ero_guest_id');
  if (s == undefined) {
    s = `guest-${+new Date()}-${Math.random().toString(36).substring(7)}`;
    ls('ero_guest_id', s);
  }
  return s;
}

export function gup(name, url) {
  if (typeof window === 'undefined') return '';

  if (!url) url = location.href;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regexS = '[\\?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? '' : results[1];
}

export function initializeAxios() {
  if (typeof window === 'undefined') return;

  axios.defaults.timeout = 10 * 60 * 1000;

  axios.interceptors.request.use(
    config => {
      const token = getToken();
      const url = new URL(config.url);
      if (token != undefined) {
        url.searchParams.set('token', token);
      }
      url.searchParams.set('ero_guest_id', getGuestId());
      config.url = url.toString();
      const utmData = getUtm();
      if (utmData != undefined) {
        Object.keys(utmData).forEach(key => {
          config.headers[`x-eroplay-source-${key}`.toLowerCase()] = utmData[key];
        });
      }
      try {
        config.headers['x-eroplay-source-ga-client-id'] = CommonHelper.getGAClientId();
      } catch (_exc) {
        // Error intentionally ignored
      }

      const deviceParams = getDeviceParams();
      if (deviceParams != undefined) {
        Object.keys(deviceParams).forEach(key => {
          config.headers[`x-eroplay-device-${key}`.toLowerCase()] = deviceParams[key];
        });
      }
      config.headers['x-eroplay-visitor-id'] = getGuestId();

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
} 